import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';
import { Component } from '@angular/core';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { WritableSignal, signal } from '@angular/core'; // Import the necessary signal function

@Component({
  selector: '[cdp-toast]',
  styles: [
    `:host {
        background-color: #fafafa;
        position: relative;
        overflow: hidden;
        font-size: 13px;
        margin: 0 0 6px;
        padding: 20px 10px 20px 20px;
        width: 300px;
        border-radius: 3px;
        border-left: 4px solid var(--dw-brand-color2);
        color: #3f3f3f;
        pointer-events: all;
        cursor: pointer;
        box-shadow: 1px 1px #eaeaea;
    }

    .toastr-wrapper {
        display: flex;
        align-items: center;
        padding-right: 5px;
        border-radius: 3px;
        position: relative;
        z-index: 10;
    }

    .icon-success, .icon-error {
        margin-right: 15px;
        font-size: 16px;
    }

    .icon-success i {
        color: #00d27f;
    }

    .icon-error i {
        color: #ed3d3d;
    }`
  ],
  template: `
    <div class="row" [style.display]="state().value === 'inactive' ? 'none' : ''">
        <div class="col-10">
            <div class="toastr-wrapper">
                <div *ngIf="success" class="icon-success">
                    <i class="far fa-check-circle"></i>
                </div>
                <div *ngIf="error" class="icon-error">
                    <i class="far fa-times-circle"></i>
                </div>
                <div *ngIf="message && options.enableHtml" role="alert" aria-live="polite"
                    [class]="options.messageClass" [innerHTML]="message">
                </div>
                <div *ngIf="message && !options.enableHtml" role="alert" aria-live="polite"
                    [class]="options.messageClass" [class.error]="error" [attr.aria-label]="message">
                    {{ message }}
                </div>
            </div>
        </div>
        <div class="col-1 text-right">
            <a *ngIf="options.closeButton" (click)="remove()">
                <span class="ng-tns-c3-0" aria-hidden="true">×</span>
            </a>
        </div>
    </div>
    <div *ngIf="options.progressBar">
        <div class="toast-progress" [style.width]="width + '%'"></div>
    </div>
  `,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      transition('inactive => active', animate('400ms ease-out', keyframes([
        style({ transform: 'translate3d(100%, 0, 0) skewX(-30deg)', opacity: 0 }),
        style({ transform: 'skewX(20deg)', opacity: 1 }),
        style({ transform: 'skewX(-5deg)', opacity: 1 }),
        style({ transform: 'none', opacity: 1 })
      ]))),
      transition('active => removed', animate('400ms ease-out', keyframes([
        style({ opacity: 1 }),
        style({ transform: 'translate3d(100%, 0, 0) skewX(30deg)', opacity: 0 })
      ])))
    ])
  ],
  preserveWhitespaces: false,
})
export class CdpToastr extends Toast {
  success: boolean = false;
  error: boolean = false;

  // Initialize state using signal()
  state: WritableSignal<{ value: "inactive" | "active" | "removed"; params: { easeTime: string | number; easing: string; }; }> = signal({
    value: 'inactive',
    params: {
      easeTime: 400,
      easing: 'ease-out',
    },
  });

  constructor(
    protected toastrService: ToastrService,
    public toastPackage: ToastPackage
  ) {
    super(toastrService, toastPackage);

    if (this.toastPackage.toastType === 'toast-success') {
      this.success = true;
    } else if (this.toastPackage.toastType === 'toast-error') {
      this.error = true;
    }
  }

  action(event: Event) {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    return false;
  }
}
